import React, { useEffect, useState } from "react";
import "./modal.css";
import Modal from "react-modal";
import "animate.css";
import { RxCross2 } from "react-icons/rx";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Gbtn from "../buttons/Gbtn";


export default function ModalComp({
  isLoading,
  isVisible,
  isErr = false,
  errMsg = 'Some error occured please again try later.',
  setIsVisible,
  msg = "Are you sure you want to delete?",
  onCnfrm = () => { },
}) {

  useEffect(() => {
    Modal.setAppElement("#root");
  }, []);


  return (
    <>
      <Modal
        isOpen={isVisible}
        className="deleteModal animate__animated animate__zoomIn"
        style={{ display: "flex" }}
      >
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div
              className="delClient-cross"
              onClick={(e) => {
                setIsVisible(false);
              }}
            >
              <RxCross2 color="white" size={"20"} />
            </div>
            <>
              <p style={{ display: isErr ? 'block' : 'none', color: 'red', textAlign: 'center', }}>{errMsg}</p>
              <h3 style={{ color: "white", marginBottom: "60px" }}>
                {msg}
              </h3>

              <Gbtn
                text="Delete"
                color="#EE282E"
                radius="6px"
                width="40%"
                func={onCnfrm}
              />
            </>
          </>
        )}
      </Modal>
    </>
  );
}
